import { BRAND } from '../../config/brand'
/**
 * The name the scheduling copy speaks with.
 *
 * These sentences are about the ASSISTANT acting — "picked this time and can
 * still move it", "leaves it where it is" — so this is `BRAND.assistant`, the
 * voice, not `BRAND.name`, the product. The two are different on purpose; see
 * `src/config/brand.ts`.
 *
 * It was a hardcoded literal until 2026-09-06, when the owner moved every
 * on-screen name into one file. The constant survives because a dozen strings
 * import it and because the doctrine test has a single symbol to point at, but
 * it is now an alias rather than a source of truth: change the name in
 * `brand.ts` and this follows.
 */

export const PRODUCT_NAME = BRAND.assistant
